<script>

    import { toast } from 'bulma-toast'

    import ShipmentsService from '../$services/shipments.service'
    import TrackingsService from '../$services/trackings.service'

    import DateMethods from '../$methods/date.methods'

    import Image from '../$components/image.svelte'
    import Value from '../$components/value.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let params = {}

    let loading = false
    let shipment = null
    let tracking = null

    if(params.shipmentId)
        getShipment()

    async function getShipment() {

        loading = true
        const resp = await ShipmentsService.getShipment(params.shipmentId)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shipment = resp.data
        getTrackingsShipment()
    }

    async function getTrackingsShipment() {

        loading = true
        const resp = await TrackingsService.getTrackingsShipment(params.shipmentId)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tracking = resp.data
    }

</script>

<style>
    .body {
        background-color: #3033AF;
        background-image: linear-gradient(90deg, #3033AF 0%, #B36BE1 100%);
        height: 100vh;
        overflow-y: scroll;
    }

    .centerContent {
        display: flex;
        justify-content: center;
    }
    .content {
        background: white;
        padding: 32px;
        border-radius: 16px;
        min-width: 25vw;
    }
</style>

<div class="body">
    <div class="centerContent">
        <div class="content space top bottom">
            <div class="columns">
                <div class="column">
                    <div class="items center">
                        <Image src="/images/brand.png" size="128x128" />
                    </div>
                </div>
            </div>
            <hr>
            <div class="columns">
                <div class="column">
                    <Spinner {loading} />
                </div>
            </div>
            {#if shipment && tracking}
                <div class="columns">
                    <div class="column">
                        <div class="title">
                            {shipment.provider} {shipment.service}
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <Value label="Origen" value={`${shipment.pickup.state}, ${shipment.pickup.city}`}/>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <Value label="Destino" value={`${shipment.delivery.state}, ${shipment.delivery.city}`}/>
                    </div>
                </div>
                {#if tracking.length}
                    <div class="columns">
                        <div class="column">
                            <div class="timeline">
                                <header class="timeline-header">
                                <span class="tag is-medium is-primary">Inicio</span>
                                </header>
                                {#each tracking as item}
                                    <div class="timeline-item ">
                                        <div class="timeline-marker">
                                        </div>
                                        <div class="timeline-content">
                                            <p class="heading">{ DateMethods.dateTimeLarge(item.created) }</p>
                                            <div>
                                                <div class="title is-5">{ item.name }</div>
                                                <div class="subtitle is-6">{ item.details }</div>
                                            </div>
                                        </div>
                                    </div>
                                    {#if item.status === 'Entregado'}
                                        <div class="timeline-header">
                                            <span class="tag is-medium is-primary">Finalizado</span>
                                        </div>
                                    {/if}
                                {/each}
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}
        </div>
    </div>
</div>